export  default {
    setUsage(state, payload) {
        state.usage = payload;
      },
};